<div class="modal fade" id="kt_modal_vehicle_update" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered mw-1000px">
    <div class="modal-content">
      <div class="modal-header p-3 d-flex justify-content-between bg-secondary">
        <h2 class="fw-bold m-0">Update Vehicle</h2>
        <div class="btn btn-icon btn-sm btn-active-icon-primary" data-bs-dismiss="modal">
          <i class="ki-duotone ki-cross fs-1">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
        </div>
      </div>

      <form [formGroup]="vehicleForm" (ngSubmit)="onSubmit()" novalidate>
        <div class="modal-body p-5">
          <div class="row">
            <!-- Basic Vehicle Information (Read-only) -->
            <div class="col-12 mb-5">
              <h4 class="fw-bold text-dark mb-3">Vehicle Information (Read-only)</h4>
            </div>

            <!-- Car Number -->
            <div class="col-md-4 mb-5">
              <label class="form-label">Car Number</label>
              <input
                type="text"
                class="form-control form-control-solid"
                formControlName="car_no"
                readonly
              />
            </div>

            <!-- Inventory Number -->
            <div class="col-md-4 mb-5">
              <label class="form-label">Inventory Number</label>
              <input
                type="text"
                class="form-control form-control-solid"
                formControlName="inventory_no"
                readonly
              />
            </div>

            <!-- Vehicle Name -->
            <div class="col-md-4 mb-5">
              <label class="form-label">Vehicle Name</label>
              <input
                type="text"
                class="form-control form-control-solid"
                formControlName="name"
                readonly
              />
            </div>

            <!-- Company -->
            <div class="col-md-4 mb-5">
              <label class="form-label">Company</label>
              <input
                type="text"
                class="form-control form-control-solid"
                formControlName="company_name"
                readonly
              />
            </div>

            <!-- Year -->
            <div class="col-md-3 mb-5">
              <label class="form-label">Year</label>
              <input
                type="text"
                class="form-control form-control-solid"
                formControlName="year"
                readonly
              />
            </div>

            <!-- Mileage -->
            <div class="col-md-3 mb-5">
              <label class="form-label">Mileage</label>
              <input
                type="text"
                class="form-control form-control-solid"
                formControlName="mileage"
                readonly
              />
            </div>

            <!-- Fuel Type -->
            <div class="col-md-3 mb-5">
              <label class="form-label">Fuel Type</label>
              <input
                type="text"
                class="form-control form-control-solid"
                formControlName="fuel_type"
                readonly
              />
            </div>

            <!-- Transmission -->
            <div class="col-md-3 mb-5">
              <label class="form-label">Transmission</label>
              <input
                type="text"
                class="form-control form-control-solid"
                formControlName="transmission"
                readonly
              />
            </div>

            <!-- Doors -->
            <div class="col-md-3 mb-5">
              <label class="form-label">Doors</label>
              <input
                type="text"
                class="form-control form-control-solid"
                formControlName="doors"
                readonly
              />
            </div>

            <!-- Color -->
            <div class="col-md-3 mb-5">
              <label class="form-label">Color</label>
              <input
                type="text"
                class="form-control form-control-solid"
                formControlName="color"
                readonly
              />
            </div>

            <!-- VIN Number -->
            <div class="col-md-3 mb-5">
              <label class="form-label">VIN Number</label>
              <input
                type="text"
                class="form-control form-control-solid"
                formControlName="vin_no"
                readonly
              />
            </div>

            <!-- Location -->
            <div class="col-md-3 mb-5">
              <label class="form-label">Location</label>
              <input
                type="text"
                class="form-control form-control-solid"
                formControlName="location"
                readonly
              />
            </div>

            <!-- Price -->
            <div class="col-md-4 mb-5">
              <label class="form-label">Price</label>
              <input
                type="text"
                class="form-control form-control-solid"
                formControlName="price"
                readonly
              />
            </div>

            <!-- Engine -->
            <div class="col-md-4 mb-5">
              <label class="form-label">Engine</label>
              <input
                type="text"
                class="form-control form-control-solid"
                formControlName="engine"
                readonly
              />
            </div>

            <!-- Separator -->
            <div class="col-12 my-5">
              <div class="separator separator-dashed"></div>
            </div>

            <!-- Editable Fields -->
            <div class="col-12 mb-5">
              <h4 class="fw-bold text-primary mb-3">Editable Fields</h4>
            </div>

            <!-- Select Yard -->
            <div class="col-md-6 mb-5">
              <label class="form-label">Select Yard</label>
              <select
                class="form-select form-select-solid"
                formControlName="yard">
                <option value="">Select Yard</option>
                <option *ngFor="let yard of yardsList" [value]="yard.value">{{ yard.label }}</option>
              </select>
            </div>

            <!-- Yard Date -->
            <div class="col-md-6 mb-5">
              <label class="form-label">Yard Date</label>
              <input
                type="date"
                class="form-control form-control-solid"
                formControlName="yard_date"
                placeholder="Select yard date"
              />
            </div>

            <!-- BL Documents -->
            <div class="col-md-6 mb-5">
              <label class="form-label">BL Documents</label>
              <input
                #fileInput
                type="file"
                class="form-control form-control-solid"
                (change)="onFileSelected($event)"
                accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
              />
              <div class="form-text text-muted">Upload BL documents (PDF, DOC, DOCX, JPG, PNG)</div>
            </div>

            <!-- Selected File Display -->
            <div class="col-12 mb-3" *ngIf="fileUrl" (click)="openFile()" style="cursor: pointer;">
              <div class="alert alert-info d-flex align-items-center">
                <i class="ki-duotone ki-file fs-2 me-3">
                  <span class="path1"></span>
                  <span class="path2"></span>
                </i>
                <div>
                  <strong>Selected File:</strong> {{ fileUrl }}
                  <br>
                  <!-- <small class="text-muted">Size: {{ (selectedFile.size / 1024 / 1024).toFixed(2) }} MB</small> -->
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-light me-3"
            data-bs-dismiss="modal"
            [disabled]="isLoading">
            Cancel
          </button>
          <button
            type="submit"
            class="btn btn-primary"
            [disabled]="isLoading || vehicleForm.invalid">
            <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
            <span *ngIf="isLoading">Updating...</span>
            <span *ngIf="!isLoading">Update Vehicle</span>
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
